import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { historyMedicineQuantity } from '../../services/clinic/medicine';


function MedicinePurchaseHistory() {
    const navigate = useNavigate();
    const location = useLocation();

    const [tableData, setTableData] = useState({});

    const headers = [
        { label: "Quantity", key: "quantity_purchased" },
        { label: "Purchase Date", key: "purchase_date" },
        { label: "Purchase Price", key: "purchase_price" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);


    const pageSize = 10;

    const fetchData = async (id) => {
        setLoading(true);
        try {
            let res = await historyMedicineQuantity(id);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch medicines");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Medicines:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (location.state) {
            fetchData(location.state.item.id);
        } else {
            navigate('/medicine');
        }
    }, []);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/invoice' },
            { name: 'Medicines', link: '/medicine' },
            { name: 'Purchase History' },
        ]} />
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"Medicine Purchase History Of " + location.state.item.drug_name} />
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                quantity_purchased: <p>{item.quantity_purchased}</p>,
                                purchase_date: <p>{item.purchase_date}</p>,
                                purchase_price: <p>₹ {item.purchase_price}</p>,
                            }
                        )
                        )}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
    </>);
}

export default MedicinePurchaseHistory;